import React, { useContext } from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import LayoutContext from '../../../contexts/Layout';
import ComponentContainer from '../../common/ComponentContainer';

export const Legal = ({ followContentLink, legalText, privacyPolicyLink }) => {
    const { layout } = useContext(LayoutContext);

    if (!legalText) {
        return null;
    }

    return (
        <ComponentContainer style={layout.device.isMobile ? Styles.containerMobile : Styles.container}>
            <Text numberOfLines={1} style={Styles.legalText}>
                {legalText}
            </Text>
            <Text
                onPress={async () => await followContentLink(privacyPolicyLink.isExternal, privacyPolicyLink.internalKey, privacyPolicyLink.externalUrl)}
                style={Styles.privacyLinkText}
            >
                {'Privacy Policy'} and {'Terms of Use'}
            </Text>
        </ComponentContainer>
    );
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        height: 50,
        justifyContent: 'center',
        marginBottom: 0
    },
    containerMobile: {
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 0
    },
    legalText: {
        fontFamily: 'GothamBook',
        color: '#7f868b',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12
    },
    privacyLinkText: {
        fontFamily: 'GothamBook',
        color: '#153d6e',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12,
        marginLeft: 5
    }
});
